import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';

const ServersTable = ({ servers, onRemove, onSort }) => {
    const rows = servers.map((server, index) => <Row key={index} server={server} onRemove={onRemove}/>);

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSort('name')}>Name</th>
                    <th onClick={() => onSort('ip')}>IP</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default ServersTable;


// WEBPACK FOOTER //
// ./src/scenes/Servers/components/Table/index.js